import {PropsWithChildren} from "react";

interface PageProps extends PropsWithChildren {
    className?: string;
    pageId?: string;
}

const Page = ({className, pageId, children}: PageProps) => {

    return (
        <div className={`page ${className ?? ""} ${pageId ? `page--${pageId}` : ""}`}>
            {children}
        </div>
    );

}

export default Page;